import { render, staticRenderFns } from "./PageIndicators.vue?vue&type=template&id=2cb0c99b"
import script from "./PageIndicators.vue?vue&type=script&lang=ts"
export * from "./PageIndicators.vue?vue&type=script&lang=ts"
import style0 from "./PageIndicators.vue?vue&type=style&index=0&id=2cb0c99b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports